import { ModalType, useModalContext } from 'modules/campaigns/editor/context';
import { DestructiveButton, BUTTON_SIZES } from 'ui/button';
import { Stop } from 'ui/icons';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const DeActivateCampaignAction = () => {
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action="activate">
      <DestructiveButton
        data-test="deactivate-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.DeactivateCampaignModal)}
      >
        <Stop height={20} />
        Deactivate campaign
      </DestructiveButton>
    </CampaignPermissionCheck>
  );
};
